<template>
  <div class="my-message-index-div1">
    <table style="width: 100%;" cellspacing="0" cellpadding="0">
      <tr height="50px">
        <td>
          <div class="my-message-index-div2">
            <span class="my-message-index-span1">留言反馈</span>
          </div>
        </td>
      </tr>
      <tr>
        <td class="my-message-index-td2">
          <div class="my-message-index-div3">
            <span>欢迎访问，请留下您宝贵的意见，我们真诚的为您服务</span>
          </div>
          <div style="position: relative; top: 10px;">
            <el-form ref="myForm1" :model="myForm1" label-width="400px" :rules="rules" class="my-message-form">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="myForm1.name"></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="telephone">
                <el-input v-model="myForm1.telephone"></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱" prop="email">
                <el-input v-model="myForm1.email"></el-input>
              </el-form-item>
              <el-form-item label="留言内容" prop="content">
                <el-input v-model="myForm1.content" type="textarea"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('myForm1')">提交</el-button>
                <el-button @click="resetForm('myForm1')">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import Vuex from 'vuex'

  import {
    insertMessage
  } from '@/api/message.js'

  export default {
    name: "MessageIndex",
    data() {
      var reg1 =
        /(^[\u4e00-\u9fa5]{1}[\u4e00-\u9fa5\.·。]{0,8}[\u4e00-\u9fa5]{1}$)|(^[a-zA-Z]{1}[a-zA-Z\s]{0,18}[a-zA-Z]{1}$)/;
      var checkName = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('请输入姓名'));
        } else if (!reg1.test(value)) {
          callback(new Error('请输入正确的姓名'));
        } else {
          callback();
        }
      };
      const reg2 = /^1[3|4|5|7|8][0-9]\d{8}$/;
      var checkTelephone = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('请输入手机号码'));
        } else if (!reg2.test(value)) {
          callback(new Error('请输入正确的手机号码'));
        } else {
          callback();
        }
      };
      var checkContent = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('请输入留言内容'));
        } else {
          callback();
        }
      };

      return {
        myForm1: {
          name: '',
          telephone: '',
          email: '',
          content: '',
        },
        rules: {
          name: [{
            validator: checkName,
            trigger: 'blur',
            required: true,
          }],
          telephone: [{
            validator: checkTelephone,
            trigger: 'blur',
            required: true,
          }],
          email: [{
              required: false,
              message: '请输入邮箱地址',
              trigger: 'blur'
            },
            {
              type: 'email',
              message: '请输入正确的邮箱地址',
              trigger: ['blur', 'change']
            }
          ],
          content: [{
            validator: checkContent,
            trigger: 'blur',
            required: true,
          }]
        },
      };
    },
    components: {},
    methods: {
      submitForm(formName) {
        var that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            insertMessage('message/insert', this.$data.myForm1)
            that.$alert('感谢您的留言', '留言成功', {
              confirmButtonText: '确定',
              showClose: false,
            });
            this.$router.push({
              path: "/"
            });
          } else {
            alert('请填写完整在做提交');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    },
    computed: {
      ...Vuex.mapGetters(["getInfo"])
    },
    created() {
      this.$store.state.activeIndex = "6";
    }
  }
</script>

<style>
  .my-message-index-div1 {
    width: 1200px;
    margin: 0 auto;
  }

  .my-message-index-span1 {
    font-size: 25px;
    font-weight: bold;
    color: white;
  }

  .my-message-index-div2 {
    width: 260px;
    background: royalblue;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
  }

  .my-message-index-td2 {
    border: 0px hidden;
    background: white;
  }


  .my-message-index-div3 {
    height: 60px;
    width: 1000px;
    line-height: 60px;
    text-align: center;
    vertical-align: middle;
    margin: 0px auto;
    border-bottom: 0.5px dashed #000000;
    font-size: 15px;
  }


  .my-message-form {
    width: 800px;
  }
</style>



// WEBPACK FOOTER //
// src/components/message/MessageIndex.vue